var Monitor = {
    uid: null,
    startTime: null,
    pageInitInfo: {},
    sessionId: "",
    options: {
        baseUrl: "",
        unionid: "",
        openid: "",
        projectId: "",
        projectName: "",
        api_key: "",
        currentPageUrl: "",
        ad_id: "",
        debug: false,
    },
    init: function (options) {
        if (options.openid) {
            this.uid = options.openid;
        } else {
            this.uid = localStorage.getItem("uid");
        }
        if (!this.uid) {
            this.uid = Math.random().toString(36).substr(2);
            localStorage.setItem("uid", this.uid);
        }

        if (options.debug) {
            console.log("大数据调试开启");
        }

        this.options = Object.assign(this.options, options);

        if (this.options.ad_id) {
            this.eventAddAdmerics();
        }

        window.addEventListener("error", (error) => {
            this.sendEvent("/event/error", {
                message: error,
            });
        });

        window.addEventListener("load", (result) => {
            this.recordPageView(result);
            // this.getDeviceInfo();
        });

        window.addEventListener("beforeunload", () => {
            var stayTime = Date.now();
            this.sendEvent("/event/stay", {
                stayTime: stayTime,
            });
        });
    },

    recordPageView: function (result) {
        this.pageInitInfo = result;
        this.recordReferrer(result, () => {
            if (this.uid) {
                this.createSession(() => {
                    this.recordPageChange();
                });
            }
        });
    },

    recordPageChange: function (params) {
        this.sendEvent("/pv", {
            params,
            scene: "web",
        }).then((res) => {
            if (res && res.code === 200) {
            }
        });
    },

    clickEvent: function (data) {
        this.sendEvent("/event/scene", data);
    },

    getDeviceInfo: function () {
        var deviceInfo = {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            vendor: navigator.vendor,
        };
        this.sendEvent("/event/device", deviceInfo).then((res) => {
            if (res && res.code === 200) {
            }
        });
    },

    recordReferrer: function (result, cb) {
        this.sendEvent("/event/referrer", {
            referrer: document.referrer,
        }).then((res) => {
            if (res && res.code === 200) {
                cb && cb();
            }
        });
    },

    recordConversion: function (eventType, additionalData) {
        this.sendEvent("/event/conversion", {
            eventType: eventType,
            data: additionalData,
        });
    },
    createSession: async function (cb) {
        this.sendEvent("/event/createSession").then((res) => {
            if (res && res.code === 200) {
                this.sessionId = res.data.sessionId;
                cb && cb();
            }
        });
    },

    endSession: function () {
        this.sendEvent("/event/endSession", {
            sessionId: this.sessionId,
        }).then((res) => {
            this.sessionId = "";
        });
    },

    eventShare: function () {
        this.sendEvent("/event/share");
    },

    eventAddAdmerics: function () {
        this.sendEvent("/event/addAdMetrics");
    },

    sendEvent: function (url, data = {}) {
        if (this.options.debug) {
            console.log("Sending event:", url, data);
        }
        return new Promise((resolve, reject) => {
            fetch(this.options.baseUrl + url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": this.options.api_key,
                },
                body: JSON.stringify(
                    Object.assign(
                        {
                            uid: this.uid,
                            openid: this.options.openid,
                            unionid: this.options.unionid,
                            pageUrl: window.location.href,
                            projectId: this.options.projectId,
                            projectName: this.options.projectName,
                            sessionId: this.sessionId,
                            ad_id: this.options.ad_id,
                        },
                        data
                    )
                ),
            })
                .then((response) => response.json())
                .then((data) => resolve(data))
                .catch((error) => {
                    console.error(error); // 打印错误信息
                    resolve(null); // 返回一个默认的结果
                });
                // .catch((error) => reject(error));
        });
    },
};

module.exports = Monitor
